<template>
  <LoadingDiv v-if="!isReady" />
  <form v-else class="client-settings-form" @submit.prevent="handleNext">
    <section class="settings-form-section" aria-labelledby="settings-family-heading">
      <div class="settings-form-copy">
        <h2 id="settings-family-heading">Family size</h2>
        <p>Set the total number of members covered by a family plan.</p>
      </div>
      <div class="settings-form-field">
        <label for="familySize">Total members</label>
        <input id="familySize" type="number" v-model="familySize" class="validate" required aria-describedby="settings-family-help" />
        <p id="settings-family-help">Default: 6 members — principal, spouse, and 4 dependants.</p>
      </div>
    </section>
    <section class="settings-form-section" aria-labelledby="settings-principal-heading">
      <div class="settings-form-copy">
        <h2 id="settings-principal-heading">Principal age limit</h2>
        <p>Set the maximum age for principals and spouses.</p>
      </div>
      <div class="settings-form-field">
        <label for="prinipalAge">Maximum age (years)</label>
        <input id="prinipalAge" type="number" v-model="principalAge" class="validate" required aria-describedby="settings-principal-help" />
        <p id="settings-principal-help">Default: 60 years for principals and spouses.</p>
      </div>
    </section>
    <section class="settings-form-section" aria-labelledby="settings-dependant-heading">
      <div class="settings-form-copy">
        <h2 id="settings-dependant-heading">Dependant age limit</h2>
        <p>Set the maximum age for dependants.</p>
      </div>
      <div class="settings-form-field">
        <label for="dependantAge">Maximum age (years)</label>
        <input id="dependantAge" type="number" v-model="dependantAge" class="validate" required aria-describedby="settings-dependant-help" />
        <p id="settings-dependant-help">Default: 18 years for dependants.</p>
      </div>
    </section>
    <div class="settings-form-actions">
      <button type="button" class="btn settings-form-back" @click="handleBack()"><i class="material-icons" aria-hidden="true">arrow_back</i>Back</button>
      <button type="submit" class="btn" :disabled="isSubmitting" :class="{ disabled: isSubmitting }">
        <span>{{ isSubmitting ? 'Loading...' : 'Next' }}</span><i class="material-icons" aria-hidden="true">arrow_forward</i>
      </button>
    </div>
  </form>
</template>
<script>
import { onMounted, ref } from "vue";
import getItems from "@/composables/getItems";
// import postItem from "@/composables/postItem";
import LoadingDiv from "@/components/LoadingDiv.vue";

export default {
  name: "HmoComponent",
  components: { LoadingDiv },
  emits: ["back", "next"],
  props: ["cat", "newClient"],
  setup(props, context) {
    const response = ref([]);
    const error = ref(null);
    const isSubmitting = ref(false);
    const isReady = ref(false);

    // Rules table
    const familySize = ref(null);
    const principalAge = ref(null);
    const dependantAge = ref(null);

    // check for back
    onMounted(() => {
      if (props?.newClient?.settings) {
      // reload
      familySize.value = props?.newClient?.settings?.[0].value;
      principalAge.value = props?.newClient?.settings?.[1].value;
      dependantAge.value = props?.newClient?.settings?.[2].value;
      isReady.value = true;
     }
    });

    // start here
    onMounted(() => {

      // get default items
      (async () => {
        const { res, err } = await getItems("rules?q=0"); // default settings

        if (res.value) {
          // get
          response.value = res.value.data;

          // set
          response.value.forEach((x) => {
            if (x.setting == "familySize" && familySize.value == null) {
              // set
              familySize.value = x.value;
            }

            if (x.setting == "principalAge" && principalAge.value == null) {
              // set
              principalAge.value = x.value;
            }

            if (x.setting == "dependantAge" && dependantAge.value == null) {
              // set
              dependantAge.value = x.value;
            }
          });

        } else {
          error.value = err.value;
        }
        
        // is now Ready
        isReady.value = true;
      })();

    });

     // handle back
     const handleBack = () => {
      // emit new parameters
      context.emit("back", {
            id: "settings",
            value: true,
          });
    }

    // submit
    const handleNext = async () => {
      // start
      isSubmitting.value = true;
      error.value = false;

      // Native form validation handles custom errors \\
      const newVal = [
        {
          setting: "familySize",
          value: familySize.value,
          scope: null, // props.newClient.id
        },
        {
          setting: "principalAge",
          value: principalAge.value,
          scope: null, // props.newClient.id
        },
        {
          setting: "dependantAge",
          value: dependantAge.value,
          scope: null, // props.newClient.id
        },
      ];

      // emit new parameters
      context.emit("next", {
          id: "settings",
          value: newVal,
        });

      // // post item
      // const { res, err } = await postItem("rules", newVal);

      // if (res.value) {
      //   // next
      //   // emit new parameters
      //   context.emit("next", {
      //     id: "settings",
      //     value: true,
      //   });
      // } else {
      //   error.value = err.value;
      // }

      // end here
      isSubmitting.value = false;
    };

    return {
      error,
      isReady,
      isSubmitting,
      handleNext,
      handleBack,
      familySize,
      principalAge,
      dependantAge,
    };
  },
};
</script>
  
  <style scoped>
.client-settings-form { max-width: 70rem; width: 100%; }
.settings-form-section { align-items: start; border-bottom: 1px solid var(--ui-border); display: grid; gap: 2.5rem; grid-template-columns: 13rem minmax(0, 1fr); padding: 1.75rem 0; }
.settings-form-section:first-child { padding-top: .5rem; }
.settings-form-copy h2 { color: var(--ui-foreground); font-size: 1rem; font-weight: 600; line-height: 1.5; margin: 0 0 .35rem; }
.settings-form-copy p, .settings-form-field > p { color: var(--ui-muted-foreground); font-size: .8125rem; line-height: 1.6; margin: 0; }
.settings-form-field { min-width: 0; }
.settings-form-field > label { color: var(--ui-foreground); display: block; font-size: .8125rem; font-weight: 500; line-height: 1.5; margin: 0 0 .5rem; }
.settings-form-field input { box-sizing: border-box; display: block; margin: 0; max-width: 18rem; min-height: 2.75rem; width: 100%; }
.settings-form-field > p { font-size: .75rem; margin-top: .5rem; }
.settings-form-actions { align-items: center; display: flex; flex-wrap: wrap; gap: .75rem; justify-content: space-between; padding-top: 1.25rem; }
.settings-form-actions button { font-size: .8125rem; font-weight: 600; gap: .5rem; }
.settings-form-actions i { font-size: 1rem; }
.settings-form-actions .settings-form-back { background: var(--ui-background); border: 1px solid var(--ui-border); color: var(--ui-foreground); }
@media (max-width: 900px) { .settings-form-section { gap: 1rem; grid-template-columns: minmax(0, 1fr); } }
.grey-bg-custom {
  background-color: #f2f2f2;
}
.clickable {
  cursor: pointer;
}
</style>
